import { useMutation } from '@tanstack/react-query';
import { apiClinicOnboardingClaimToken, apiClinicOnboardingCheckStatus } from 'lib/api/firebase/apis/apis';

export function useClaimOnboardingTokenMutation() {
  return useMutation({
    mutationFn: async (token: string) => {
      return apiClinicOnboardingClaimToken({ token });
    }
  });
}

export function useCheckOnboardingStatusMutation() {
  return useMutation({
    mutationFn: async (token: string) => {
      return apiClinicOnboardingCheckStatus({ token });
    }
  });
}
